// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rlal1","colBig":"styles_colBig__3BbB9","colSmall":"styles_colSmall__N9foi","shopifyNameWrapper":"styles_shopifyNameWrapper__39gsw"};